import { useTranslation } from "react-i18next";
import { Select, type SelectOption } from "@akuna/ui";
import type { StayModule } from "./theme";

const OPTIONS: StayModule[] = ["day_care", "hotel"];

export function ReservationTypeToggle({ value, onChange }: { value: StayModule; onChange: (value: StayModule) => void }) {
  const { t } = useTranslation("daycareHotel");
  return (
    <Select
      label={t("reservationType")}
      options={OPTIONS.map((option): SelectOption => ({ value: option, label: t(option === "hotel" ? "typeHotel" : "typeDaycare") }))}
      value={value}
      forceNative
      onValueChange={(next) => onChange(next as StayModule)}
    />
  );
}
